import { c as _c } from "react/compiler-runtime";
import './child-bio-details.scss';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { ChildBioInfo } from './child-bio-info';
export const ChildBioDetailsHeading = t0 => {
  const $ = _c(22);
  const {
    details,
    seoLevel: t1,
    className,
    showIcons: t2
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  const showIcons = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["bio"];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation(t3);
  const {
    hangul,
    name
  } = details;
  const Comp = `h${seoLevel}` as ElementType;
  let t4;
  if ($[1] !== showIcons) {
    t4 = cn("ChildBioDetails__heading", {
      "py-comfy-xs px-comfy-sm": showIcons
    });
    $[1] = showIcons;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== className || $[4] !== showIcons) {
    t5 = cn("heading-potent heading-xl mb-comfy-sm", className, {
      "text-center": showIcons
    });
    $[3] = className;
    $[4] = showIcons;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      color: "var(--theme-heading-color)"
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = hangul.preferred || name.preferred;
  let t8;
  if ($[7] !== name.preferred || $[8] !== t || $[9] !== t7) {
    t8 = t("bio:title", {
      childName: name.preferred,
      koreanName: t7,
      interpolation: {
        escapeValue: false
      }
    });
    $[7] = name.preferred;
    $[8] = t;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== Comp || $[12] !== t5 || $[13] !== t8) {
    t9 = <Comp className={t5} style={t6}>{t8}</Comp>;
    $[11] = Comp;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== details || $[16] !== showIcons) {
    t10 = showIcons && <ChildBioInfo details={details} variant="icons" />;
    $[15] = details;
    $[16] = showIcons;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t4 || $[20] !== t9) {
    t11 = <div className={t4}>{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t4;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};